<script lang="ts">
	import '../app.css';

	import { beforeNavigate } from '$app/navigation';
	import { page, updated } from '$app/state';
	import Footer from '$lib/components/Footer.svelte';
	import Header from '$lib/components/header/Header.svelte';
	import Notifications from '$lib/components/notification/Notifications.svelte';
	import Providers from '$lib/components/Providers.svelte';
	import ThirdParties from '$lib/components/third-parties/ThirdParties.svelte';

	let { data, children } = $props();

	// Refresh page if new version available
	beforeNavigate(({ willUnload, to }) => {
		if (updated.current && !willUnload && to?.url) {
			location.href = to.url.href;
		}
	});

	const activeAnnouncements = (data.store.announcements ?? []).filter((n: Announcement) => {
		return data.todayFrDate >= n.from_date && (!n.to_date || data.todayFrDate <= n.to_date);
	});

	// TMP: hide country selectors
	// let sortedSiblings = data.store.siblings.sort((a: SiblingCountry, b: SiblingCountry) => {
	// 	const [langA, countryA] = a.locale.split('_');
	// 	const [langB, countryB] = b.locale.split('_');
	// 	const nameA = getCountryDisplayName(countryA, langA)!;
	// 	const nameB = getCountryDisplayName(countryB, langB)!;
	// 	return nameA.localeCompare(nameB);
	// });
	const sortedSiblings: Config['siblings'] = [];
</script>

<svelte:head>
	<link rel="icon" href={`${data.store.media_base_url}${data.store.favicon_path}`} />

	<title>{page.data.title}{page.route.id !== '/' ? ` | ${page.data.store.store_name}` : ''}</title>
	<meta name="description" content={page.data.metaDescription} />

	<meta property="og:type" content="website" />
	<meta property="og:url" content={page.url.toString()} />
	<meta property="og:title" content={page.data.title} />
	<meta property="og:description" content={page.data.metaDescription} />
	<meta property="og:locale" content={page.data.store.locale} />
	<meta property="og:site_name" content={page.data.store.default_title} />
</svelte:head>

<Providers>
	<ThirdParties sfbxAppKey={data.sfbx_app_key} thirdParties={data.store.third_parties} />
	<div class="flex min-h-dvh flex-col">
		<div
			class={['sticky top-0 z-20', { 'border-b border-b-neutral-300': page.url.pathname !== '/' }]}
		>
			<Header
				name={data.store.name}
				logo_url={`${data.store.base_url}${data.store.logo_path}`}
				menu={data.menu}
				announcement={activeAnnouncements.length ? activeAnnouncements[0].content : ''}
				siblings={sortedSiblings}
				currentCountry={data.store.country}
			/>
		</div>

		<div class={[{ 'mx-5 mt-[var(--header-margin)] grow': page.url.pathname !== '/' }]}>
			<Notifications />
			{@render children()}
		</div>

		<Footer store={data.store} brandsBlock={data.brandsBlock} />
	</div>
</Providers>
